export const Colors = {
    white: '#fff',
    black: '#232325',
    grey: 'rgba(0, 0, 0, 0.5)',
    blue: '#121453',
    whiteBroken: '#f2f0eb'
}

export const Breakpoints = {
    small: '640px',
    wide: '1024px'
}

export const Sizes = {
    maxContainerWidth: '1160px',
    maxContentWidth: '720px'
}

export const FontLight = () => `
    font-family: 'GT America Light', sans-serif;
    font-weight: normal;
    -webkit-font-smoothing: antialiased;
    -khtml-font-smoothing: antialiased;
    -apple-font-smoothing: antialiased;
    font-smooth: always;
`

export const FontRegular = () => `
    font-family: 'GT America Regular', sans-serif;
    font-weight: normal;
    -webkit-font-smoothing: antialiased;
    -khtml-font-smoothing: antialiased;
    -apple-font-smoothing: antialiased;
    font-smooth: always;
`

export const FontBold = () => `
    font-family: 'GT America Bold', sans-serif;
    font-weight: normal;
    -webkit-font-smoothing: antialiased;
    -khtml-font-smoothing: antialiased;
    -apple-font-smoothing: antialiased;
    font-smooth: always;
`